import { render, staticRenderFns } from "./BillboardView.vue?vue&type=template&id=62605dce"
import script from "./BillboardView.vue?vue&type=script&lang=js"
export * from "./BillboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports